import PageLayout from '@/components/PageLayout';
import React from 'react';
import { getLayoutProps } from '@/utils/layout/layout';
import FaqPageSection from '@/components/FaqPage/FaqPage';
import Head from 'next/head';
import styles from '@/styles/Corporate.module.css';
import { getOrFetchCorporateData } from '@/utils/corporateCalls';
import { CustomMetaHead } from '@/components/CustomMetaHead/CustomMetaHead';

export default function Faqs({ faqs, responsiveLogo, metadata }) {
  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <CustomMetaHead metadata={metadata} />

      <main className={styles.mainContainer}>
        <div className={styles.categoriesContainer}>{faqs && <FaqPageSection faqs={faqs} />}</div>
      </main>
    </>
  );
}

Faqs.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticProps(context) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);
  const [{ data: faqData }] = await Promise.all([getOrFetchCorporateData('faq_page', context.locale)]);

  const faqs = faqData?.data[0] ? faqData : null;
  const metadata = faqs?.data[0]?.content?.metadata;

  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      faqs,
      messages,
      ...(metadata ? { metadata } : null),
    },
  };
}
